












import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class WxHeader extends Vue {
    @Prop(String) private readonly title!: string;
    @Prop(String) private readonly logo?: string;

    private hndlDrawer() {
        this.$emit('drawer');
    }
}
